// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1ZRLL","tab":"Tabs_tab__Qka4O","tabActive":"Tabs_tabActive__18EWt"};